import React, { useState } from 'react'
import { AiOutlineCopy } from 'react-icons/ai'
import { copyToClipboard } from '../../utils'
import IconButton from './IconButton'

type Props = {
  text: string
}

const CopyToClipboardButton = ({ text }: Props) => {
  const [copied, setCopied] = useState(false)

  return (
    <IconButton
      type="link"
      iconSize={14}
      icon={AiOutlineCopy}
      onClick={() => {
        copyToClipboard(text).then(() => {
          setCopied(true)
          setTimeout(() => {
            setCopied(false)
          }, 1000)
        })
      }}
    >
      {copied ? 'Copied' : 'Copy to clipboard'}
    </IconButton>
  )
}

export default CopyToClipboardButton
